import { isSSR } from '#shared/utils/isSSR';
import { isDevelopment } from '#shared/utils/isDevelopment';

export default (hostlink) => (url) => {
  if (isDevelopment() && !isSSR()) {
    return url;
  }
  return `${hostlink}${url}`;
};
